<template>
<w-setting-sliding-popup ref="slidingPopup" :title="popupTitle" width="500px" @open="open" @close="close">
  <div slot="content">
    <el-form :model="rsctypeFormData" label-position="top" :rules="rules" ref="rsctypeForm">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="자원구분 ID" prop="rsctypeId">
            <el-input v-model="rsctypeFormData.rsctypeId" placeholder="입력해 주세요." :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="자원구분명" prop="rsctypeName">
            <el-input v-model="rsctypeFormData.rsctypeName" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-form-item label="적용" prop="applystatFlag">
          <el-switch v-model="rsctypeFormData.applystatFlag" active-value="Y" inactive-value="N" style="height:28px"></el-switch>
        </el-form-item>
      </el-row> -->
    </el-form>
  </div>
  <el-row slot="footer" type="flex" justify="center">
    <el-button size="large" type="solid" class="mr-r4" @click="saveButton">저장</el-button>
    <el-button size="large" @click="cancelButton">취소</el-button>
  </el-row>
</w-setting-sliding-popup>
</template>

<script>
import RscSettingsAPI from '@/api/settings/common/rsc-settings';
import msgUtil from '@/utils/message';

export default {
  name: 'WUpdateRsctypePopup',
  props: {
    managetypeId: String,
    managetypeKey: String,
    updateRow: Object,
  },
  data() {
    return {
      popupTitle: null,
      rsctypeFormData: {
        rsctypeId: null,
        rsctypeName: null,
        applystatFlag: 'Y',
      },
      rules: {
        rsctypeName: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
      },
    };
  },
  methods: {
    open() {
      this.popupTitle = `${this.updateRow.rsctypeName} 정보`;
      this.rsctypeFormData = this.updateRow;
    },
    close() {
      this.$refs.rsctypeForm.resetFields();
    },
    saveButton() {
      const managetypeId = this.managetypeId;
      const managetypeKey = this.managetypeKey;
      const rsctypeFormData = this.rsctypeFormData;
      rsctypeFormData.managetypeId = managetypeId;
      rsctypeFormData.managetypeKey = managetypeKey;
      this.$refs.rsctypeForm
        .validate()
        .then((response) => {
          if (response) {
            const action = msgUtil.action.SAVE;
            const target = '자원 구분';
            RscSettingsAPI.updateRsctypes([rsctypeFormData])
              .then((res) => {
                if (res.data.success) {
                  this.$message(msgUtil.getResultMsgData(action, target, true));
                  this.$emit('re-load');
                  this.cancelButton();
                } else {
                  this.$message(msgUtil.getResultMsgData(action, target, false));
                }
              })
              .catch(() => {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              });
          }
        })
        .catch(() => {});
    },
    cancelButton() {
      this.$refs.slidingPopup.visible = false;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/CollectionSettings/RscSettings/popup/UpdateRsctypePopup.vue